const quiz = function () {
  return {
    products: [],
    important_product: null,
    has_important_answer: false,
    step_length: 0,
    step: 1,
    preloader: false,
    form_submited: this.$persist(false),
    show_products: false,
    show_copied: false,
    filtered_products: [],
    products_html: [],
    start_quiz: false,
    id_list: [],
    sorted_product_ids: [],
    sorted_products: [],
    email: "",
    submitting: false,
    submit_error: "",

    checkProducts(answer, isImportant = false) {
      if (isImportant) {
        this.has_important_answer = true;
      }

      this.products.forEach((product) => {
        if (product.options.includes(answer)) {
          product.rating += 1;
        }
      });
      this.step += 1;
      this.show_products = false;
      this.$el.classList.add("active");

      if (this.step > this.step_length) {
        this.getProducts();
      }
    },

    sortProducts() {
      const sorted_products = this.products.slice(0, 3);
      this.filtered_products = sorted_products;
    },

    async submitToAttentive(products) {
      if (!this.email || this.submitting) return;

      this.submitting = true;
      this.submit_error = "";

      const workerUrl =
        "https://vmax-attentive-proxy.bandeira-agency.workers.dev";

      // Quiz results as comma-separated string (Attentive doesn't support arrays)
      const quizResultsStr = Array.isArray(products) ? products.join(",") : "";
      const recommendedStr = Array.isArray(this.id_list)
        ? this.id_list.join(",")
        : "";

      try {
        // STEP 1: Subscribe user (create or update subscriber)
        const subscribeRes = await fetch(workerUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            action: "subscribe",
            payload: {
              user: { email: this.email },
              signUpSourceId: 1346471, // TODO: Replace with actual integer ID from Attentive
            },
          }),
        });

        if (!subscribeRes.ok) {
          const error = await subscribeRes.json().catch(() => ({}));
          console.error("Attentive subscribe error:", error);
          throw new Error("Subscription failed");
        }

        // STEP 2: Set custom attributes on subscriber profile
        const attributesRes = await fetch(workerUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            action: "attributes",
            payload: {
              user: { email: this.email },
              properties: {
                quiz_results: quizResultsStr,
                recommended_products: recommendedStr,
              },
            },
          }),
        });

        if (!attributesRes.ok) {
          const error = await attributesRes.json().catch(() => ({}));
          console.error("Attentive attributes error:", error);
          throw new Error("Setting attributes failed");
        }

        // STEP 3: Send custom event to trigger journey (with full product data for Dynamic List)
        await fetch(workerUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            action: "event",
            payload: {
              type: "quiz_completed",
              user: { email: this.email },
              properties: {
                products: this.sorted_products,
              },
            },
          }),
        });

        this.form_submited = true;
      } catch (error) {
        console.error("Attentive submission error:", error);
        this.submit_error = "Something went wrong. Please try again.";
      } finally {
        this.submitting = false;
      }
    },

    fetchProductCard(product) {
      const url = `${window.Shopify.routes.root}products/${product.handle}?view=card`;
      return fetch(url)
        .then((res) => res.text())
        .then((data) => {
          const parser = new DOMParser().parseFromString(data, "text/html");
          const card = parser.querySelector(".quiz-card");
          if (!card) return null;

          card.setAttribute("data-rating", `${product.rating}`);
          card.setAttribute("data-product-id", product.id);
          this.products_html.push({ card, product });
          this.id_list.push(product.id);
          return { card, product };
        })
        .catch((error) => {
          console.log(error);
          return null;
        });
    },

    applyImportantProduct(sorted) {
      const result = {
        sorted,
        replaced: null,
      };

      if (
        !this.has_important_answer ||
        !this.important_product ||
        sorted.length < 2
      ) {
        return result;
      }

      const importantId = String(this.important_product.id);
      const alreadyIncluded = sorted.some(
        (item) => String(item.product.id) === importantId,
      );

      if (alreadyIncluded) {
        return result;
      }

      const importantItem = this.products_html.find(
        (item) => String(item.product.id) === importantId,
      );

      if (!importantItem) {
        return result;
      }

      // After swap: index 1 is recommended. Replace the weakest among the rest.
      const nonRecommendedIndexes = sorted
        .map((_, index) => index)
        .filter((index) => index !== 1);

      if (nonRecommendedIndexes.length === 0) {
        return result;
      }

      const weakestIndex = nonRecommendedIndexes.reduce((weakest, index) => {
        const weakestRating = Number(sorted[weakest].card.dataset.rating) || 0;
        const currentRating = Number(sorted[index].card.dataset.rating) || 0;
        return currentRating < weakestRating ? index : weakest;
      }, nonRecommendedIndexes[0]);

      const replacedProduct = sorted[weakestIndex].product;
      sorted[weakestIndex] = importantItem;

      result.sorted = sorted;
      result.replaced = {
        removed: {
          id: String(replacedProduct.id),
          title: replacedProduct.title,
          rating: Number(replacedProduct.rating) || 0,
        },
        important: {
          id: String(importantItem.product.id),
          title: importantItem.product.title,
        },
        index: weakestIndex,
      };

      return result;
    },

    getProducts() {
      this.preloader = true;
      if (this.products.length > 0) {
        const productsToFetch = [...this.products];
        const importantAlreadyInList =
          this.important_product &&
          this.products.some(
            (product) =>
              String(product.id) === String(this.important_product.id),
          );

        if (this.important_product && !importantAlreadyInList) {
          productsToFetch.push(this.important_product);
        }

        productsToFetch.forEach((product) => {
          this.fetchProductCard(product);
        });

        setTimeout(() => {
          const quizProductIds = new Set(
            this.products.map((product) => String(product.id)),
          );
          let sorted = this.products_html
            .filter((item) => quizProductIds.has(String(item.product.id)))
            .sort((a, b) => b.card.dataset.rating - a.card.dataset.rating)
            .slice(0, 3);

          if (sorted.length === 0) {
            this.preloader = false;
            return;
          }

          const banner = `<div class="featured-banner"><span>Our
          Recommendation</span></div>`;
          const first_item = sorted[1];
          sorted[1] = sorted[0];
          sorted[0] = first_item;
          const featured = sorted[1].card.querySelector(
            ".quiz-card__container",
          );
          featured.insertAdjacentHTML("afterbegin", banner);
          featured.classList.add("featured");

          const { sorted: finalSorted, replaced } =
            this.applyImportantProduct(sorted);
          sorted = finalSorted;

          const sortedProductIds = sorted.map((item) =>
            item.card.getAttribute("data-product-id"),
          );

          // Store full product data for Attentive
          this.sorted_products = sorted.map((item) => ({
            productId: String(item.product.id),
            title: item.product.title,
            description: item.product.description || "",
            imageUrl: item.product.image.startsWith("//")
              ? "https:" + item.product.image
              : item.product.image,
            productUrl: item.product.url,
            price: item.product.price,
          }));

          console.log("[Quiz] Results", {
            hasImportantAnswer: this.has_important_answer,
            productIds: sortedProductIds,
            products: this.sorted_products.map((product) => ({
              id: product.productId,
              title: product.title,
            })),
            recommended: {
              id: String(sorted[1]?.product.id),
              title: sorted[1]?.product.title,
            },
            replaced: replaced
              ? {
                  removed: replaced.removed,
                  important: replaced.important,
                  slotIndex: replaced.index,
                }
              : null,
          });

          sorted.forEach((item) => {
            this.$refs.productContainer.insertAdjacentHTML(
              "beforeend",
              item.card.innerHTML,
            );
          });

          this.preloader = false;
          this.show_products = true;
          this.sorted_product_ids = sortedProductIds;
        }, 1000);
      } else return;
    },
    openQuiz() {
      document.getElementsByTagName("html")[0].classList.add("no_scroll");
      this.start_quiz = true;
    },

    closeQuiz() {
      document.getElementsByTagName("html")[0].classList.remove("no_scroll");
      this.start_quiz = false;
      this.show_products = false;
      this.step = 1;
      this.has_important_answer = false;
      this.products_html = [];
      this.$refs.productContainer.innerHTML = "";
      document.querySelectorAll(".quiz__answer").forEach((el) => {
        el.classList.remove("active");
      });
    },

    copyCode(code) {
      window.navigator.clipboard.writeText(code);
      this.show_copied = true;
      setTimeout(() => {
        this.show_copied = false;
      }, 500);
    },
  };
};

document.addEventListener("alpine:init", () => {
  Alpine.data("quiz", quiz);
});
